<template>
  <v-container>
  <v-form
        ref="createForm"
        v-model="valid"
        lazy-validation
        >
    <v-row justify="start">
      <v-col cols="12" md="4">
        <v-combobox
          v-model="createNewInvoice.customer"
          :items="customerItems"
          item-text="name"
          item-value="organizationId"
          :search-input.sync="search"
          v-bind:label="$t('customer')"
          :rules="[v => !!v || $t('customerRequired')]"
          @click:clear="clearCustomerItems"
          @change="checkCustomer"
          clearable
          append-icon=""
          persistent-hint
          v-bind:hint="$t('characterforSearch')"
        >
         <!--<template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('noResult') }} "<strong>{{ search }}</strong>". {{ $t('click') }} <kbd>enter</kbd> {{ $t('forNewEntry') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>-->
        </v-combobox> 
        <v-text-field
        v-if="newCustomer"
        v-model="customer.mb"
        v-bind:label="$t('mbNumber')"
        :rules="[v => !!v || $t('mbRequired')]"
        required>
        </v-text-field>
        <v-text-field
        v-if="newCustomer"
        v-model="customer.pib"
        v-bind:label="$t('pib')"
        :rules="[v => !!v || $t('pibRequired')]"
        required>
        </v-text-field>
        <v-text-field
        v-if="newCustomer"
        v-model="customer.street"
        v-bind:label="$t('address')">
        </v-text-field>
        <v-text-field
        v-if="newCustomer"
        v-model="customer.city"
        v-bind:label="$t('city')">
        </v-text-field>
        <v-text-field
        v-if="newCustomer"
        v-model="customer.postalZone"
        v-bind:label="$t('postalZone')">
        </v-text-field>
        <v-text-field
        v-if="newCustomer"
        v-model="customer.country"
        v-bind:label="$t('country')">
        </v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          v-model="createNewInvoice.documentType"
          :items="documentTypesItems"
          :item-text="getDocumentTypeText"
          item-value="documentTypeId"
          :rules="[v => !!v || $t('documentTypeRequired')]"
          v-bind:label="$t('documentType')"
          @change="changeDocumentType"
          v-bind:no-data-text="$t('noData')"
          return-object
          required
        >
        </v-select>
        <v-select
        v-show="createNewInvoice.documentType != null && createNewInvoice.documentType.documentTypeId >= 5"
        v-model="itemCode"
        :items="itemsCodes"
        item-text="code"
        item-value="code"
        v-bind:label="$t('itemCode')"
        v-bind:no-data-text="$t('noData')"
        :rules="itemCodeRule"
        >
        </v-select>
      </v-col>
      <v-col cols="8" md="4">
        <v-btn
          :dark="!executingOperation"
          :disabled="executingOperation"
          color="#2b5d66"
          @click="createInvoiceForm">
          {{ $t('create') }}
        </v-btn>
      </v-col>
    </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { i18n } from '../main'

export default {
  name: "CreateInvoice",
  components: {
  },
  data() {
    return {
      customer: {
        organizationId: -1,
        name: "",
        mb: "",
        pib: "", 
        street: "", 
        postalZone: "",
        city: "", 
        country: "", 
        CountryCode: "",
        jbkjs: ""
      },
      newCustomer: false,
      search: null,
      valid: true,
      itemCode: "",
      customerItems: [],
      documentTypesItems: [],
      itemsCodes: [],
      createNewInvoice: {
        documentType: null,
        customer: null,
        invoice: "",
        id: -1
      },
      executingOperation: false
    };
  },
  mounted() {
    this.getDocumentTypes(); 
    this.getItemsCodes();    
    //this.getCustomers();   
  },
  watch: {
    search (val) {
      val && val.length > 2 && this.getCustomers()
    },
  },
  computed: {
    selectedOrganization() {
      return this.$store.getters.organizationId;
    },
    loggedUser() {
      return this.$store.getters.loggedUser;
    },
    feesPermission() {
      const isFound = this.loggedUser.permission.some(element =>{
      if(element.permission === 'Fees' && element.organizationId === this.selectedOrganization)
        return true;
      });
      return isFound;
    },
    salesPermission() {
      const isFound = this.loggedUser.permission.some(element =>{
      if(element.permission === 'SalesInvoice' && element.organizationId === this.selectedOrganization)
        return true;
      });
      return isFound;
    },
    itemCodeRule() {
        const rules = []
        if(this.createNewInvoice.documentType != null && this.createNewInvoice.documentType.documentTypeId >= 5) {
            if(this.itemCode.length == 0){
                const rule = v => !!v || this.$t('itemCodeRequired')
                rules.push(rule) 
            }
        }
        return rules
    },
  },
  methods: {
    getDocumentTypes() {
      this.axios.get('InvoiceUtilities/GetDocumentTypes').then((response) => {
        this.documentTypesItems = response.data;
        if(!this.feesPermission) {
          this.documentTypesItems = this.documentTypesItems.filter(t =>  { return t.documentTypeId < 5 })
        }
        else if(this.feesPermission && !this.salesPermission) {
          this.documentTypesItems = this.documentTypesItems.filter(t =>  { return t.documentTypeId >= 5 })
        }
      })
      .catch(err => console.log(err));
    }, 
    getCustomers() { 
      this.axios.get('Organization/GetCustomers?organizationId=' + this.selectedOrganization + '&name=' + this.search).then((response) => {
        this.customerItems = response.data;
      })
      .catch(err => console.log(err));
    },
    addCustomer: function(e) {
      if(this.search != null && this.search.length > 1) {
        if (e.keyCode === 13){
          this.newCustomer = true
        }
      }
    },
    checkCustomer() {
      if(this.createNewInvoice.customer && this.createNewInvoice.customer.organizationId != null)
        this.newCustomer = false
    },
    clearCustomerItems() {
      this.newCustomer = false
      this.customer = {
        organizationId: -1,
        name: "",
        mb: "",
        pib: "", 
        street: "", 
        postalZone: "",
        city: "", 
        country: "", 
        CountryCode: "",
        jbkjs: ""
      }
      this.customerItems = []
    },
    createInvoiceForm() {
      this.executingOperation = true;
      var formData = new FormData();
      if(this.$refs.createForm.validate()) {
        if(this.createNewInvoice.customer.organizationId != null) {
          
          formData.append('invoiceJson', JSON.stringify(this.createNewInvoice))
          this.axios.post('SalesInvoices/SaveInvoiceNumber?organizationId=' + this.$store.getters.organizationId + '&code=' + this.itemCode, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
              }).then(response => {
                if(response && response.status === 200) {
                  console.log(response)
                  this.createNewInvoice.id = response.data.id;
                  this.createNewInvoice.invoice = response.data.invoice;
                  this.$router.push({ name: 'InvoiceForm', params: {createNewInvoice: this.createNewInvoice, code: this.itemCode }});
                }
            })
            .catch(function (error) {
                console.log(error)
                if (error.response) {
                  console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);
                }
                else if (error.request) {
                  console.log(error.request);
                } 
            })
        }
        else {
          if(!this.newCustomer){
            this.newCustomer =  true;
            this.$root.displayNotificationMsg(this.$t('newCustomerDataRequired'), 'warning');
            this.executingOperation = false;
          }
          else {
            this.customer.name = this.createNewInvoice.customer;
            this.createNewInvoice.customer = this.customer;

            formData.append('invoiceJson', JSON.stringify(this.createNewInvoice));
            this.axios.post('SalesInvoices/SaveInvoiceNumber?organizationId=' + this.$store.getters.organizationId + '&code=' + this.itemCode, formData, {
                  headers: {
                      "Content-Type": "multipart/form-data"
                  }
                }).then(response => {
                  if(response && response.status === 200) {
                  this.createNewInvoice.id = response.data.id;
                  this.createNewInvoice.invoice = response.data.invocie;
                  this.$router.push({ name: 'InvoiceForm', params: {createNewInvoice: this.createNewInvoice }});
                }
              })
              .catch(function (error) {
                  console.log(error)
                  if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                  }
                  else if (error.request) {
                    console.log(error.request);
                  } 
              })
            }
        }
      }
      else
      {
        this.$root.displayNotificationMsg(this.$t('dataRequired'), 'warning');
        this.executingOperation = false;
      }      
    },
    getDocumentTypeText(item) {
      if(i18n.locale === 'eng')
        return item.documentTypeEng;
      else
        return item.documentType;
    },
    getItemsCodes() {
        this.itemsCodes = this.loggedUser.itemCode.filter(c =>  { return c.organizationId ==  this.selectedOrganization || c.organizationId == -1});
        console.log(this.loggedUser.itemCode)
        console.log(this.itemsCodes)
        if(this.itemsCodes.length > 1)
          this.itemsCodes = this.itemsCodes.slice(1);
    }, 
    changeDocumentType() {
      if(this.createNewInvoice.documentType != null && this.createNewInvoice.documentType.documentTypeId < 5)
        this.itemCode = "";
    },
  },
};
</script>

<style scoped>
</style>